interface SubTabItem<T extends string> {
  value: T;
  label: string;
}

interface SubTabControlProps<T extends string> {
  items: readonly SubTabItem<T>[];
  active: T;
  onChange: (value: T) => void;
}

/**
 * Horizontal segmented control for switching between sub-content views inside a tab.
 */
export function SubTabControl<T extends string>({
  items,
  active,
  onChange,
}: SubTabControlProps<T>) {
  return (
    <div className="sub-tab-control" role="tablist">
      {items.map((item) => (
        <button
          key={item.value}
          role="tab"
          aria-selected={active === item.value}
          onClick={() => onChange(item.value)}
          className={`sub-tab ${active === item.value ? 'active' : ''}`}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
